export enum CatGender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}

export interface Cat {
  id: string
  name: string
  gender: CatGender
  location: {
    address: string
    lat: number
    lng: number
  }
  images: string[]
  bio: string
  date_founded: string
  color: string
}
